import * as React from 'react';
import { Row, Col } from 'react-bootstrap';
import type { CustomRouteComponentProps } from 'react-router-dom';
import { withRouter } from 'react-router-dom';
import type { InjectedFormProps } from 'redux-form';
import { Field } from 'redux-form';

import type AgencyVM from 'ab-viewModels/agency/agency.viewModel';

import type UpsertTemporaryEmployeeRM from 'ab-requestModels/temporaryEmployee.requestModel';

import CLIENT from 'af-constants/routes/client';

import { Button } from '@acceligentllc/storybook';

import Dropdown from 'af-fields/Dropdown';
import Input from 'af-fields/Input';

import LabelWithColor from 'af-components/LabelWithColor';
import SubmitButton from 'af-components/SubmitButton';

import styles from '../styles.module.scss';

interface OwnProps {
	agencies: Nullable<AgencyVM[]>;
	companyName: string;
	onSubmit: (form: UpsertTemporaryEmployeeRM) => Promise<void>;
}

type FormOwnProps = OwnProps & InjectedFormProps<UpsertTemporaryEmployeeRM> & CustomRouteComponentProps<void>;

interface PathParams {
	temporaryEmployeeId: string;
}

type Props = FormOwnProps & (CustomRouteComponentProps | CustomRouteComponentProps<PathParams>);

const FILTER_AGENCY_BY = ['name', 'email', 'phone', 'website'];

const renderAgency = (option: AgencyVM) => <LabelWithColor color={option.color} text={<strong>{option.name}</strong>} />;

const TemporaryEmployeeForm: React.FC<Props> = (props: Props) => {
	const {
		agencies,
		companyName,
		onSubmit,
		invalid,
		submitting,
		handleSubmit,
		location: { state: { orgAlias } },
		history,
	} = props;

	const goBack = React.useCallback(() => {
		history.push(CLIENT.COMPANY.RESOURCES.TEMPORARY_EMPLOYEE.LIST(orgAlias, companyName));
	}, [history, orgAlias, companyName]);

	return (
		<div>
			<div className="form-box-highlighted-input">
				<Row className="row--padded-top">
					<Col sm={8}>
						<Field
							component={Input}
							label="First Name"
							name="firstName"
							placeholder="Enter First Name"
							required={true}
							type="text"
						/>
					</Col>
					<Col sm={8}>
						<Field
							component={Input}
							label="Last Name"
							name="lastName"
							placeholder="Enter Last Name"
							required={true}
							type="text"
						/>
					</Col>
				</Row>
				<Row>
					<Col sm={8}>
						<Field
							component={Input}
							label="Email"
							name="email"
							placeholder="Email"
							type="text"
						/>
					</Col>
					<Col sm={8}>
						<Field
							component={Input}
							label="Phone Number"
							name="phoneNumber"
							placeholder="Phone Number"
							type="tel"
						/>
					</Col>
				</Row>
				<Row>
					<Col sm={8}>
						<Field
							component={Dropdown}
							filterable={true}
							filterBy={FILTER_AGENCY_BY}
							label="Agency"
							name="agencyId"
							options={agencies}
							placeholder="Select Agency"
							renderMenuItem={renderAgency}
							valueKey="id"
							withCaret={true}
						/>
					</Col>
				</Row>
			</div>
			<div className={styles.footerActions}>
				<Button
					label="Cancel"
					onClick={goBack}
					style="secondary"
					type="button"
				/>
				<SubmitButton
					disabled={invalid}
					onClick={handleSubmit(onSubmit)}
					reduxFormSubmitting={submitting}
					variant="primary"
				/>
			</div>
		</div>
	);
};

export default withRouter(TemporaryEmployeeForm);
